import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {useEffect, useState} from 'react'
import {QUERY_KEYS} from '@/queryClient.ts'
import {PaginationResponse} from '@/types.ts'
import {
    httpGetMedicalReportsByPatient,
    HttpGetMedicalReportsByPatientOptions,
    HttpGetMedicalReportsByPatientResponse
} from '../http/medicalReports.http'

export const useGetMedicalReportsByPatient = ({
    urlParams,
    params,
    options
}: {
    urlParams: HttpGetMedicalReportsByPatientOptions['urlParams']
    params: HttpGetMedicalReportsByPatientOptions['params']
    options?: Omit<UseQueryOptions<HttpGetMedicalReportsByPatientResponse>, 'queryKey' | 'queryFn'>
}) => {
    const [persistedPagination, setPersistedPagination] = useState<PaginationResponse>({
        total: 0,
        lastPage: 1,
        perPage: 50,
        currentPage: 1
    })

    const query = useQuery({
        queryKey: [QUERY_KEYS.PATIENT_MEDICAL_RECORD, urlParams, params],
        queryFn: () => httpGetMedicalReportsByPatient({urlParams, params}),
        ...options
    })

    useEffect(() => {
        if (query.isSuccess) {
            setPersistedPagination(query.data.meta)
        }
    }, [query.data?.data.length])

    return {...query, persistedPagination}
}
